import { z } from 'zod';

export const shopSchema = z.object({
  shop_id: z.string().min(1).max(64),
  name: z.string().min(1).max(128),
  created_at: z.string().datetime({ offset: true }),
});

export type Shop = z.infer<typeof shopSchema>;

export const dashboardSummarySchema = z.object({
  shop_id: z.string(),
  machine_count: z.number().int().nonnegative(),
  running_count: z.number().int().nonnegative(),
  idle_count: z.number().int().nonnegative(),
  alarm_count: z.number().int().nonnegative(),
  offline_count: z.number().int().nonnegative(),
  avg_oee_percent: z.number().min(0).max(100),
  active_alarm_count: z.number().int().nonnegative(),
});

export type DashboardSummary = z.infer<typeof dashboardSummarySchema>;
